import { ShippingDocumentKind } from "generated-graphql/graphql";

import { formatContainerDate, NO_VALUE_PLACEHOLDER } from "../Containers/containerDisplay";

export { NO_VALUE_PLACEHOLDER };
export const formatShippingDocumentDate = formatContainerDate;

export const SHIPPING_DOCUMENT_KIND_LABELS: Record<ShippingDocumentKind, string> = {
  [ShippingDocumentKind.BillOfLading]: "Bill of Lading",
  [ShippingDocumentKind.Manifest]: "Manifest",
  [ShippingDocumentKind.Other]: "Other",
};

export const SHIPPING_DOCUMENT_KIND_OPTIONS = Object.values(ShippingDocumentKind).map((value) => ({
  value,
  label: SHIPPING_DOCUMENT_KIND_LABELS[value],
}));
